import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo, useRef, useEffect } from 'react';
import { Icons } from '@/js/libs/ui/src/V2';
import { isEqualOptions } from '../../helpers';
import { OptionWrapper, CheckmarkWrapper } from './styled';
const _OptionSelect = ({ option, selected, isFocused = false, onClick, optionSelected, formatOptionLabel }) => {
    const isSelected = useMemo(() => {
        if (!selected) {
            return false;
        }
        return optionSelected ? optionSelected(selected, option) : isEqualOptions(selected, option);
    }, [selected, option, optionSelected]);
    const label = useMemo(() => (formatOptionLabel ? formatOptionLabel(option) : option.label), [formatOptionLabel, option]);
    const ref = useRef(null);
    // Scroll into view when focused
    useEffect(() => {
        if (isFocused && ref.current) {
            ref.current.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
    }, [isFocused]);
    return (_jsxs(OptionWrapper, { onClick: onClick, "$isSelected": isSelected, "$isFocused": isFocused, ref: ref, "data-testid": 'option-label', children: [_jsx("span", { children: label }), isSelected && (_jsx(CheckmarkWrapper, { children: _jsx(Icons.Checkmark, { size: 20 }) }))] }));
};
export const OptionSelect = memo(_OptionSelect);
